
var id = "materialDelete";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"materialDelete\">\n<path d=\"M5 3.99935L5.4 1.66602H10.6L11 3.99935\" stroke=\"#333333\" stroke-width=\"1.33\" stroke-linejoin=\"round\" />\n<path d=\"M2 4H14\" stroke=\"#333333\" stroke-width=\"1.33\" stroke-linecap=\"round\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.3332 4L11.6665 14.3333H4.33317L3.6665 4H12.3332Z\" stroke=\"#333333\" stroke-width=\"1.33\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M6.33301 11.666H9.66634\" stroke=\"#333333\" stroke-width=\"1.33\" stroke-linecap=\"round\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
